import React from 'react';

const PaginationButtons = ({ totalPages, currentPage, onPageChange }) => {
    return (
        <div className='text-center block px-0 py-[1em]'>
            <div className='flex items-center justify-center text-center mx-auto p-0'>
                {/* Previous Button */}
                <div>
                    <a
                        onClick={() => onPageChange(currentPage - 1)}
                        className='font-bold font-Serif lg:font-NotoSansKR text-sm cursor-pointer block bg-[#eee] lg:bg-slate text-black lg:text-white w-[32px] h-[32px] leading-[32px] mr-[5px] mb-[5px] lg:rounded-[5px] border border-black hover:bg-skyblue lg:hover:bg-deep-blue transition-all duration-300 ease-in-out'
                    >
                        <i className="fa fa-chevron-left mt-2.5" aria-hidden="true"></i>
                    </a>
                </div>

                {/* Page Numbers */}
                {Array.from({ length: totalPages }, (_, index) => {
                    const page = index + 1;
                    return (
                        <div key={index}>
                            <a
                                onClick={() => onPageChange(page)}
                                className={`${page === currentPage
                                    ? 'bg-skyblue lg:bg-deep-blue text-white'
                                    : 'bg-[#eee] lg:bg-slate text-black lg:text-white'
                                    } font-bold font-Serif lg:font-NotoSansKR text-sm cursor-pointer block w-[32px] h-[32px] leading-[32px] mr-[5px] mb-[5px] lg:rounded-[5px] border border-black hover:bg-skyblue hover:text-white lg:hover:bg-deep-blue transition-all duration-300 ease-in-out`}
                            >
                                {page}
                            </a>
                        </div>
                    );
                })}

                {/* Next Button */}
                <div>
                    <a
                        onClick={() => onPageChange(currentPage + 1)}
                        className='font-bold font-Serif lg:font-NotoSansKR text-sm cursor-pointer block bg-[#eee] lg:bg-slate text-black lg:text-white w-[32px] h-[32px] leading-[32px] mr-[5px] mb-[5px] lg:rounded-[5px] border border-black hover:bg-skyblue hover:text-white lg:hover:bg-deep-blue transition-all duration-300 ease-in-out'
                    >
                        <i className="fa fa-chevron-right mt-2.5" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PaginationButtons;
